import { EMPTY_FIELD } from 'constants/emptyField';
import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import {
  ChipField,
  EmbeddedFunctionField,
  FunctionField,
  SingleFieldList,
  TextField,
} from 'shared/react-admin/Fields';
import { ReferenceArrayField } from 'shared/react-admin/ReferenceFields';
import { Commission } from 'types/embedded/commission';

type Props = {
  omit?: string;
  relatedField: React.ReactNode;
};

export const CommissionsTabsInfo: React.FC<Props> = ({ omit, relatedField }) => {
  const translate = useTypedTranslate();
  const { hasResourceAccess } = usePermissions();

  return (
    <CardTable tableBodyProps={{ sx: { '& td': { width: '185px' } } }}>
      <TableRowWrapper label={translate('app.commissions.type')}>
        <TextField source="typeEnum.description" />
      </TableRowWrapper>
      <TableRowWrapper label={translate('app.commissions.relatedCommissions')}>
        {relatedField}
      </TableRowWrapper>
      {omit !== 'provider' && hasResourceAccess('merchants') && (
        <TableRowWrapper label={translate('app.table.merchant')}>
          <EmbeddedFunctionField
            linkConfig={{ resource: 'merchants', idField: 'merchant.@id' }}
            sourceField="merchant.name"
          />
        </TableRowWrapper>
      )}
      {hasResourceAccess(Resources.Providers) && (
        <TableRowWrapper label={translate('app.table.provider')}>
          <FunctionField render={(record: Commission) => record.provider?.name || EMPTY_FIELD} />
        </TableRowWrapper>
      )}
      {hasResourceAccess(Resources.Currencies) && (
        <TableRowWrapper label={translate('app.table.currency')}>
          <FunctionField
            render={(record: Commission) =>
              record.currency
                ? `${record.currency.alphaCode}, ${record.currency.name}`
                : EMPTY_FIELD
            }
          />
        </TableRowWrapper>
      )}
      {hasResourceAccess('transaction_types') && (
        <TableRowWrapper label={translate('app.commissions.transactionTypes')}>
          <ReferenceArrayField
            label="Типы транзакций"
            reference="transaction_types"
            source="transactionTypes"
          >
            <SingleFieldList linkType={false}>
              <ChipField source="name" />
            </SingleFieldList>
          </ReferenceArrayField>
        </TableRowWrapper>
      )}
    </CardTable>
  );
};
